'use strict';

if (typeof Map === 'undefined') {
    window.Map = require('core-js/es6/map');
}

if (typeof Set === 'undefined') {
    window.Set = require('core-js/es6/set');
}

if (typeof Promise === 'undefined') {
    require('promise/lib/rejection-tracking').enable();
    window.Promise = require('promise/lib/es6-extensions.js');
}

Object.assign = require('object-assign');

if (typeof requestAnimationFrame === 'undefined' || typeof cancelAnimationFrame === 'undefined') {
    require('raf').polyfill();
}

if (!String.prototype.padStart) {
    String.prototype.padStart = require('string.prototype.padstart');
}



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 150
// module chunks = 0